import {DjPsycho} from "../DjPsycho";
import {DjPsychoGameMode} from "../server/DjPsychoGameMode";
import {DjPsychoFSIntroRunner} from "./DjPsychoFSIntroRunner";

export class DjPsychoSFSIntroRunner extends DjPsychoFSIntroRunner {

    public shouldRun(): boolean {
        return ((DjPsycho.model.gameData.mode === DjPsychoGameMode.NORMAL || DjPsycho.model.gameData.mode === DjPsychoGameMode.NORMAL_AVALANCHE) && DjPsycho.model.gameData.nextMode === DjPsychoGameMode.FREESPIN_SUPER)
            || ((DjPsycho.model.gameData.mode === DjPsychoGameMode.FREESPIN || DjPsycho.model.gameData.mode === DjPsychoGameMode.FREESPIN_AVALANCHE) && DjPsycho.model.gameData.nextMode === DjPsychoGameMode.FREESPIN_SUPER);
    }
}